import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import '../MostPrefferedTestSeries/../header/style.css';
import { Header } from ".";
import { AdminNavbar } from ".";
import { API_BASE_URL, ACCESS_TOKEN_NAME } from '../../../constants/apiConstants';

function CreateMostPreffered() {
    const navigate = useNavigate();

    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [highlightedTests, setHighlightedTests] = useState("");
    const [totalTests, setTotalTests] = useState("");
    const [freeTests, setFreeTests] = useState("");
    const [languages, setLanguages] = useState("");
    const [moreTestsCount, setMoreTestsCount] = useState("");
    const [userCount, setUserCount] = useState("");
    const [status, setStatus] = useState("");
    const [logo, setLogo] = useState(null);

    const handleFileChange = (e) => {
        setLogo(e.target.files[0]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append("title", title);
        formData.append("description", description);
        formData.append("highlighted_test_types", highlightedTests);
        formData.append("total_tests", totalTests);
        formData.append("free_tests", freeTests);
        formData.append("languages", languages);
        formData.append("more_tests_count", moreTestsCount);
        formData.append("user_count", userCount);
        formData.append("status", status);
        if (logo) {
            formData.append("media_image_name", logo);
        }

        const headers = {
            "Authorization": `Bearer ${ACCESS_TOKEN_NAME()}`
        };

        try {
            const response = await fetch(`${API_BASE_URL}/createMostPreferredTestSeries/null`, {
                method: "POST",
                headers,
                body: formData,
                redirect: "follow"
            });

            const result = await response.text();

            if (response.ok) {
                console.log("Success:", result);
                navigate("/admin/mostPrefferedList");
            } else {
                console.error("Error:", result);
            }
        } catch (error) {
            console.error("API Error:", error);
        }
    };

    return (
        <div>
            <Header />
            <div className="main-container">
                <AdminNavbar />
                <div className="main">
                    <div className="report-container">
                        <div className="report-header">
                            <h1 className="recent-Articles">Create Most Preferred Test Series</h1>
                        </div>
                        <div className="report-body">
                            <div className="user-form">
                                <form onSubmit={handleSubmit} encType="multipart/form-data">
                                    <div className="mb-3">
                                        <label className="form-label">Title</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={title}
                                            onChange={(e) => setTitle(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Description</label>
                                        <ReactQuill
                                            theme="snow"
                                            value={description}
                                            onChange={setDescription}
                                            style={{ marginBottom: "50px" }}
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Highlighted Test Types</label>
                                        <ReactQuill
                                            theme="snow"
                                            value={highlightedTests}
                                            onChange={setHighlightedTests}
                                            style={{ marginBottom: "50px" }}
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Total Tests</label>
                                        <input
                                            // type="number"
                                            className="form-control"
                                            value={totalTests}
                                            onChange={(e) => setTotalTests(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Free Tests</label>
                                        <input
                                            // type="number"
                                            className="form-control"
                                            value={freeTests}
                                            onChange={(e) => setFreeTests(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Languages (comma separated)</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={languages}
                                            onChange={(e) => setLanguages(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">+More Tests Count</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            value={moreTestsCount}
                                            onChange={(e) => setMoreTestsCount(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">User Count</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={userCount}
                                            onChange={(e) => setUserCount(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Logo (Upload Image)</label>
                                        <input
                                            type="file"
                                            className="form-control"
                                            accept="image/*"
                                            onChange={handleFileChange}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Status</label>
                                        <select
                                            className="form-control"
                                            value={status}
                                            onChange={(e) => setStatus(e.target.value)}
                                            required
                                        >
                                            <option value="">Select Status</option>
                                            <option value="1">Active</option>
                                            <option value="0">Inactive</option>
                                        </select>
                                    </div>

                                    <button type="submit" className="btn btn-primary submit-btn">
                                        CREATE
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CreateMostPreffered;
